import React, { useEffect, useState } from 'react';
import CommonServiceInfoBar from '@pages/Beneficiary-block/WomenComponent/CommonServiceInfoBar';
import BadgesComponent from '@components/common/Badges';
import PlusSvgIcon from '../../../../../assets/svg_main/plus.svg';
import Button from '@components/common/Button';
import './ReferralOverview.css'
import { useNavigate, useParams } from 'react-router-dom';
import { getFacilityReferralList } from '../FacilityReferralUtils/FacilityReferralServices';
import { useDispatch } from 'react-redux';
import { setFacilityMetaData, setFacilityServiceData } from '@store/actions/beneficiaryAction';
import { FACILITY_NAVIGATIONS } from '../FacilityReferralUtils/FacilityReferralConstants';
import { PagePermission } from '@services/usePermission';
import { MODULE_CODES, PAGE_CODES } from '@constants/moduleAndPageCodes';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { COMMON_CONSTANTS } from '@constants/index';
import { buttonNames } from '@constants/appConstants';

const ReferralOverview = () => {
    const [referralList, setReferralList] = useState<any>([]);
    const canCreateServices = PagePermission(MODULE_CODES.REFERRAL_MODULE, PAGE_CODES.REFERRAL_CREATE);
    const isChild = useSelector((state: RootState) => state.beneficiary.isChild);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const { id } = useParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        initialFetch();
    }, [])

    const initialFetch = async () => {
        const referralListRes = await getFacilityReferralList(id);
        const sortedReferralList = referralListRes.sort((a: any, b: any) => {
            return new Date(b.visit_date).getTime() - new Date(a.visit_date).getTime();
        });
        setReferralList(sortedReferralList);
        const serviceNameComplicationMap = new Map();
        sortedReferralList?.map((item: any) => {
            const { service_type_name: serviceName, beneficiary_complication_names: complicationNames } = item;
            if (serviceNameComplicationMap.has(serviceName)) {
                serviceNameComplicationMap?.set(
                    serviceName,
                    serviceNameComplicationMap?.get(serviceName)?.concat(complicationNames)
                );
            } else {
                serviceNameComplicationMap?.set(serviceName, complicationNames);
            }
        });
        const groupedData = Array.from(serviceNameComplicationMap, ([serviceName, complicationNames]) => ({
            serviceName,
            complicationNames,
        }));
        dispatch(setFacilityServiceData({ serviceNameComplicationNamesList: groupedData }));
    }

    const handleAddReferralClick = (): any => {
        dispatch(setFacilityMetaData({}));
        navigate(FACILITY_NAVIGATIONS.FACILITY_REFERRAL);
    }

    const handleView = (item: any) => {
        const metaData = {
            isHigherReferral: true,
            childFacilityId: item?.facility_referral_id,
            groupId: item?.facility_referral_group_id,
            referredFromId: item?.referred_from_facility_id,
            serviceId: item?.service_type_id,
            complicationIds: item?.beneficiary_complication_ids,
        };
        dispatch(setFacilityMetaData(metaData));
        if(isChild) {
            navigate(FACILITY_NAVIGATIONS.FACILITY_REFERRAL_CHILD_VIEW);
        } else {
            navigate(FACILITY_NAVIGATIONS.FACILITY_REFERRAL_VIEW);
        }
    }

    return (
        <div className='referral-overiew-content' >
            <div className='referal-overview-header' >
                <BadgesComponent
                    className="over-badge"
                    badgeName={'Referrals'}
                    variant="primary-1"
                    badgeType="case5"
                />                
                {canCreateServices && localStorage.getItem('userTypeName') !== COMMON_CONSTANTS.FIELD_LEVEL_USER && (
                <Button
                    onClick={handleAddReferralClick}
                    disabled={childDetails?.is_dead}
                    buttonName={buttonNames.addReferralButton}
                    id={''}
                    colorType={'primary'}
                    icon={<PlusSvgIcon />}
                    iconPosition={'left'}
                />
            )}
            </div>
            {referralList?.map((item: any, index: number) => {
                return (
                    <CommonServiceInfoBar
                        isViewIcon={true}
                        isEditIcon={false}
                        isExpand={false}
                        status={item?.status_name}
                        isEndDateRequired={false}
                        startDate={item?.visit_date}
                        serviceName={item?.referred_to_facility_name}
                        onViewClick={() => handleView(item)}
                        isExpanded={false}
                        isInfoRequired={false}
                        serviceType={item?.service_type_name}
                        complication={item?.beneficiary_complication_names}
                        key={index}
                    />
                )
            })}
        </div>
    )
}

export default ReferralOverview
